import * as THREE from 'three'


// Scene
const scene = new THREE.Scene()
scene.background= new THREE.Color(0x002C43)
const axesHelper = new THREE.AxesHelper(30)
// Object
//const geometry = new THREE.BoxGeometry(1, 1, 1)
const geometry = new THREE.TorusGeometry( 100, 1, 30, 120, )
const material = new THREE.MeshPhysicalMaterial({color: 0x9B3030})
const torus = new THREE.Mesh( geometry, material ); 
torus.material.transparent = true
material.opacity = 0.5;




const geometry2 = new THREE.TorusGeometry( 80, 1, 30, 120, )
const material2 = new THREE.MeshPhysicalMaterial({color: 0xB22C2C})
const torus2 = new THREE.Mesh( geometry2, material2 ); 
torus2.material.transparent = true
material.opacity = 0.6;

const geometry3 = new THREE.TorusGeometry( 60, 1, 30, 120, )
const material3 = new THREE.MeshPhysicalMaterial({color: 0xC82727})
const torus3 = new THREE.Mesh( geometry3, material3 ); 
torus3.material.transparent = true
material.opacity = 0.7;

const geometry4 = new THREE.TorusGeometry( 40, 1, 30, 120, )
const material4 = new THREE.MeshPhysicalMaterial({color: 0xDC1C1C})
const torus4 = new THREE.Mesh( geometry4, material4 ); 
torus4.material.transparent = true
material.opacity = 0.8;

const geometry5 = new THREE.TorusGeometry( 20, 1, 30, 120, )
const material5 = new THREE.MeshPhysicalMaterial({color: 0xEC1010})
const torus5 = new THREE.Mesh( geometry5, material5 ); 
torus5.material.transparent = true 
material.opacity = 0.9;



//myAxis vector 
//flatshape
//image as a color
//textureloader map:texture

const group = new THREE.Group();

group.add(torus);
group.add(torus2);
group.add(torus3);
group.add(torus4);
group.add(torus5);
scene.add(group);

//Object B
const geometryB = new THREE.SphereGeometry( 20, 25, 20 );
const materialB = new THREE.MeshStandardMaterial( {color: 0x000008 } ); 
const sphereB = new THREE.Mesh(geometryB, materialB );
sphereB.position.set(0,0,-50);
sphereB.rotation.x = 5*Math.PI
sphereB.material.transparent=true;
sphereB.material.opacity= 0.5;

scene.add(sphereB);


//object C
const geometryc = new THREE.SphereGeometry( 50, 32, 16 ); 
const materialc = new THREE.MeshStandardMaterial( { color: 0xff0000 } ); 
const spherec = new THREE.Mesh( geometryc, materialc ); 
spherec.position.set(-200,0,-40);
//for(let i = 0; i< 10; i++){
//console.log(spherec)


scene.add( spherec );


//Camera
// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
//Or
// const sizes = {
//     width: 400,
//     height: 300
// }
// if you want a 4:3 aspect ratio. Intro to aspect ratio
// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.set(0 ,0, 150);
scene.add(camera)

//Light
const color = 0xffeb85;
const intensity = 10;
const light = new THREE.AmbientLight(color, intensity);
scene.add(light);

const pointLight = new THREE.PointLight(color, 20, 200);
pointLight.position.set(10 ,0, 10);
pointLight.rotation.x = 90
scene.add(pointLight)



const sphereSize = 10;
const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
scene.add( pointLightHelper );

// Append the render to the canvas
const canvas = document.querySelector('canvas.animation')
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
window.addEventListener('resize',() =>{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    camera.aspect = sizes.width/sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width,sizes.height)


})

const clock = new THREE.Clock()

 const tick = () =>
 {
     const elapsedTime = clock.getElapsedTime()
     // Update objects
    group.position.x = Math.cos(elapsedTime)
    group.position.y = Math.sin(elapsedTime)
    


     // Update camera?
    //  camera.position.x = Math.sin(elapsedTime)
    //  camera.lookAt(mesh.position)

    // Render the scene
    renderer.render(scene, camera)

    // Call tick for every frame!
    window.requestAnimationFrame(tick)
 }
 
 // this is where we start the loop!
 tick()


//loop 
//style css. 200px
